module.exports = __webpack_public_path__ + "img/next-prev-sprite.862bc7cc.png";